import { Link } from 'react-router-dom';
import { FileText, QrCode, Ruler } from 'lucide-react';

export default function Hero() {
  return (
    <section className="pt-28 pb-20 sm:pt-36 sm:pb-28 px-4">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
        {/* Left content */}
        <div className="flex-1 text-center lg:text-left">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight">
            PixelUtility — Free{' '}
            <span className="bg-gradient-to-r from-brand-600 to-blue-500 bg-clip-text text-transparent">
              Browser Tools & Guides
            </span>
          </h1>
          <p className="mt-5 text-lg sm:text-xl text-gray-600 max-w-xl mx-auto lg:mx-0 leading-relaxed">
            ATS resume builder, QR code generator, and international size converter — each with
            in-depth guides, FAQs, and instant browser-based tools. No sign-up required.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
            <a
              href="#tools"
              className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-gradient-to-r from-brand-600 to-blue-500 text-white font-semibold text-sm shadow-lg shadow-brand-500/25 hover:shadow-brand-500/40 transition-all hover:-translate-y-0.5"
            >
              Browse Free Tools
            </a>
            <a
              href="https://www.buymeacoffee.com/pixelutility"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-accent-100 text-accent-500 font-semibold text-sm hover:bg-accent-200 transition-colors"
            >
              Support PixelUtility ☕
            </a>
          </div>
        </div>

        {/* Right illustration */}
        <div className="flex-1 relative w-full max-w-md lg:max-w-lg">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-brand-200/40 to-blue-200/40 rounded-3xl blur-3xl" />
            <div className="relative grid grid-cols-2 gap-4 p-8">
              <FloatingCard icon={<FileText size={24} />} label="Resume" delay="0s" to="/tools/resume-builder" />
              <FloatingCard icon={<QrCode size={24} />} label="QR Code" delay="0.5s" to="/tools/qr-code-generator" />
              <FloatingCard icon={<Ruler size={24} />} label="Sizes" delay="1s" to="/tools/clothing-shoe-size-converter" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FloatingCard({ icon, label, delay, to }) {
  return (
    <Link
      to={to}
      className="bg-white rounded-2xl p-5 shadow-lg shadow-gray-200/50 border border-gray-100 flex flex-col items-center gap-3 animate-float hover:shadow-xl transition-shadow"
      style={{ animationDelay: delay }}
    >
      <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-brand-100 to-blue-100 flex items-center justify-center text-brand-600">
        {icon}
      </div>
      <span className="text-sm font-medium text-gray-700">{label}</span>
    </Link>
  );
}
